import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const CITY_SLUG = {
  "London Heathrow Airport": "heathrow",
  "London Gatwick Airport": "gatwick",
  "Manchester Airport": "manchester",
  "Birmingham Airport": "birmingham",
  "London Stansted Airport": "stansted",
  "London Luton Airport": "luton",
  "Bristol Airport": "bristol",
  "Edinburgh Airport": "edinburgh",
  "Glasgow Airport": "glasgow",
  "Cardiff Airport": "cardiff",
  "Liverpool John Lennon Airport": "liverpool",
  "Newcastle Airport": "newcastle",
  "East Midlands Airport": "east-midlands",
  "Leeds Bradford Airport": "leeds-bradford",
  "Southampton Airport": "southampton",
  "Bournemouth Airport": "bournemouth",
  "Belfast International Airport": "belfast-international",
  "Belfast City Airport": "belfast-city",
};

export default function AirportIndex() {
  const [airports, setAirports] = useState([]);
  useEffect(() => {
    document.title = "UK Airport Parking | Compare Prices | Parkpot";
    api.get("/airports").then(r => setAirports(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-5 lg:px-8 py-12">
      <h1 className="font-display text-4xl md:text-5xl font-bold text-[var(--fpn-navy)]" data-testid="airport-index-title">UK Airport Parking</h1>
      <p className="text-slate-600 mt-3 max-w-2xl">Compare parking at every major UK airport — one search, every way to park.</p>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-10">
        {airports.map(a => (
          <Link key={a.iata_code} to={`/airport-parking/${CITY_SLUG[a.name] || a.iata_code.toLowerCase()}`}
            className="border border-slate-200 rounded-2xl p-5 bg-white card-lift" data-testid={`airport-index-${a.iata_code}`}>
            <div className="font-display text-2xl font-bold text-[var(--fpn-navy)]">{a.iata_code}</div>
            <div className="text-sm text-slate-600 mt-1">{a.name}</div>
            <div className="text-xs text-[var(--fpn-amber-2)] font-semibold mt-3">Compare parking →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
